export const ORG = {
  page: "organizations-page",
  title: "organizations-title",
  newBtn: "new-organization-btn",
  search: "organization-search-input",
  table: "organizations-table",
  emptyState: "organizations-empty",
  loading: "organizations-loading",
  // per-row (append `-${id}`)
  row: "org-row",
  viewFhirBtn: "org-view-fhir-btn",
  editBtn: "org-edit-btn",
  deleteBtn: "org-delete-btn",
  // form
  form: "organization-form",
  fName: "org-field-name",
  fActive: "org-field-active",
  fType: "org-field-type",
  fNpi: "org-field-npi",
  fTax: "org-field-taxid",
  fClia: "org-field-clia",
  fPhone: "org-field-phone",
  fFax: "org-field-fax",
  fEmail: "org-field-email",
  fLine1: "org-field-line1",
  fLine2: "org-field-line2",
  fCity: "org-field-city",
  fState: "org-field-state",
  fPostal: "org-field-postal",
  fCountry: "org-field-country",
  fAlias: "org-field-alias",
  fContactName: "org-field-contact-name",
  fContactPhone: "org-field-contact-phone",
  saveBtn: "organization-save-btn",
  cancelBtn: "organization-cancel-btn",
  // fhir viewer
  fhirDialog: "fhir-viewer-dialog",
  fhirJson: "fhir-json-content",
  fhirCopy: "fhir-copy-btn",
  // delete confirm
  deleteDialog: "delete-organization-dialog",
  confirmDelete: "confirm-delete-btn",
};
